import React from 'react'
import { withPortalAutoRemoteSync } from '../../../modules/common/withPortalAutoRemoteSync'
import { SortableListContainer } from '../../../modules/sortable/index'
import ImageListToolbar from './ImageListToolbar'
import ImageListItem from './ImageListItem'

class ImageList extends React.Component {
  handleImageSort = images => {
    this.props.updatePortalAtPath('galleryImages', images)
  }

  render() {
    return (
      <div>
        <ImageListToolbar />
        <hr />
        <SortableListContainer
          items={this.props.portal.galleryImages}
          itemsDidSorted={this.handleImageSort}
          itemComponent={ImageListItem}
        />
      </div>
    )
  }
}

export default withPortalAutoRemoteSync()(ImageList)



// WEBPACK FOOTER //
// ./src/components/templates/image-list/ImageList.js